export const ShowName = '1H23 Digital Conference';
export const TopBarTitle = ShowName;
export const ChatEnabled = false;
export const AskQuestionEnabled = false;
